import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export default function CTASection({
  title = "Une fuite d'eau ? Ne cassez rien avant de nous appeler.",
  subtitle = "Devis gratuit et intervention rapide partout en Île-de-France.",
}) {
  return (
    <section data-testid="cta-section" className="bg-ink relative overflow-hidden grain">
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-aqua/20 blur-3xl" />
      <div className="container-x py-24 relative z-10">
        <Reveal className="max-w-3xl">
          <p className="overline text-aqua mb-4">Devis gratuit</p>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white leading-tight">
            {title}
          </h2>
          <p className="mt-5 text-lg text-white/70">{subtitle}</p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Link to="/contact" data-testid="cta-devis-btn" className="btn-cta text-base px-8 py-4">
              Demander mon devis <ArrowRight size={18} />
            </Link>
            <a href={`tel:${CONTACT.phoneTel}`} data-testid="cta-call-btn" className="btn-ghost text-base px-8 py-4">
              <Phone size={18} /> {CONTACT.phoneDisplay}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
